<template>
    <li class='packageitem' :class='classes'>
        <template v-if='included'>
            <div
                class='packageitem__display'
                v-bind='triggerAttrs'
                @click='triggerClick'
                @keydown='triggerKeydown'
                tabindex='0'>


                <div class='packageitem__display__icon'>
                    <SvgIconCheck />
                </div>

                <div class='packageitem__display__title' v-html='widont(title)' />

                <a class='packageitem__display__info'>
                    <SvgIconInfo aria-label="Display information"/>
                </a>
            </div>
        </template>

        <template v-else>
            <div class='packageitem__display'>
                <div class='packageitem__display__x'>
                    <SvgIconX aria-label="Close"/>
                </div>
            </div>
        </template>

        <collapse
            class='packageitem__drawer v-collapse'
            v-bind='drawerAttrs'
            :when='isOpen'>

            <div class='packageitem__drawer__content'>

                <div class='packageitem__drawer__content__text' v-html='details' />
            </div>
        </collapse>
    </li>
</template>

<script>
const SPACE_KEYCODE = [0, 32];
const ENTER_KEYCODE = 13;
const ESC_KEYCODE = 27;

import { Collapse } from 'vue-collapsed';
import { widont } from '^/utils/typography';

import SvgIconCheck from '^/components/svg/SvgIconCheck.vue';
import SvgIconInfo from '^/components/svg/SvgIconInfo.vue';
import SvgIconX from '^/components/svg/SvgIconX.vue';

export default {
    name: 'PackageItem',
    data() {
        return {
            isOpen: false
        }
    },
    props: {
        title: {
            type: String,
            required: false
        },
        details: {
            type: String,
            required: false
        },
        featured: {
            type: Boolean,
            default: false
        },
        included: {
            type: Boolean,
            default: false
        },
        isVariantSelector: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes () {
            return {
                'packageitem--featured': this.featured,
                'packageitem--included': this.included,
                'packageitem--empty': !this.included
            }
        },
        uid () {
            return this.$.uid;
        },
        triggerId () {
            return `packageitem-${this.uid}-trigger`
        },
        drawerId () {
            return `packageitem-${this.uid}-drawer`
        },
        triggerAttrs () {
            return {
                'id': this.triggerId,
                'class': {
                    'state-open': this.isOpen
                },
                'aria-controls': this.drawerId,
                'aria-expanded': this.isOpen
            }
        },
        drawerAttrs () {
            return {
                'id': this.drawerId,
                'role': 'region',
                'aria-labelledby': this.triggerId
            }
        }
    },
    mounted () {
        document.addEventListener('documentClick', this.click);
    },
    beforeUnmount () {
        document.removeEventListener('documentClick', this.click);
    },
    methods: {
        documentClick (e) {
            // close drawer on clicks outside element
            if (!this.$el.contains(e.target)) this.closeDrawer();
        },
        triggerClick () {
            this.toggleDrawer();
        },
        triggerKeydown (e) {
            switch (e.keyCode) {
                case SPACE_KEYCODE:
                    e.preventDefault();
                    this.toggleDrawer();
                    return;

                case ENTER_KEYCODE:
                    this.toggleDrawer();
                    return;

                case ESC_KEYCODE:
                    this.closeDrawer();
                    return;

                default:
                    return;
            }
        },

        toggleDrawer () {
            if (this.isOpen) this.closeDrawer();
            else this.openDrawer();
        },
        openDrawer () {
            this.isOpen = true;
        },
        closeDrawer () {
            this.isOpen = false;
        },

        widont
    },
    components: {
        Collapse,
        SvgIconCheck,
        SvgIconInfo,
        SvgIconX
    }
};
</script>